import styled from 'styled-components/macro';
import { mediaDown } from '../../../utils/styles/media';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100vh;

  background-color: #f8f9fa;
  padding: 20px;
`;

const Container = styled.div`
  background: white;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  max-width: 500px;
  width: 100%;
`;

const Title = styled.p`
  font-size: 24px;
  color: white;
  padding-top: 20px;
  padding-bottom: 40px;
  padding-left: 30px;
  background-color: #1f4b81;
  ${mediaDown('md')`
    font-size: 40px;
  `}
`;

const Message = styled.div`
  font-size: 18px;
  color: #555;
  padding: 30px;
`;

const Button = styled.button`
  background-color: white;
  color: black;
  border: grey 1px solid;
  font-size: 16px;
  padding: 12px 24px;
  margin-top: 25px;
  border-radius: 18px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  width: 100%;
  &:hover {
    background-color: #1f4b81;
  }
`;

const Styled = {
  Wrapper,
  Container,
  Title,
  Message,
  Button,
};

export default Styled;
